export default __webpack_public_path__ + "static/media/about-2.239d989a.png";